"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    SUCCESS: 'successful',
    FAIL: 'failed',
    DEFAULT: 'default',
    LOADING: 'loading',
};
//# sourceMappingURL=formState.js.map